import PropTypes from "prop-types";
import { Accordion, AccordionTab, Iconify, NoRecordFound } from "@repo/design-system/components/ui";
import AddressPreviewCard from "../components/common/AddressPreviewCard";

const FamilySocialInfo = ({ basic = {}, isOpen, onToggle }) => {
  const headerTemplate = (
    <div className="flex align-items-center gap-2">
      <span className="flex align-items-center">
        <Iconify icon="gis:poi-map" width={16} />
      </span>
      <span>Address Information</span>
    </div>
  );

  return (
    <Accordion activeIndex={isOpen ? 0 : null} onTabChange={onToggle}>
      <AccordionTab header={headerTemplate}>
        <div className="sp-history-block">
          {basic && basic?.address ? (
            <AddressPreviewCard
              address={basic.address}
              talukaName={basic.talukaName}
              districtName={basic.districtName}
              stateName={basic.stateName}
              pincode={basic.pincode}
              nationality={basic.nationality}
            />
          ) : <NoRecordFound message="No Address Found" />}
        </div>
      </AccordionTab>
    </Accordion>
  );
};

FamilySocialInfo.propTypes = {
  basic: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default FamilySocialInfo;
